<!--
 * @Description: 
 * @Author:  
 * @Date: 2024-08-01 14:27:44
 * @LastEditTime: 2024-09-10 12:00:36
 * @LastEditors:  
-->
<template>
  <div class="main-container">
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="news-top">
      <div>
        <h1 class="news-title">{{newsDetail.title}}</h1>
        <div class="news-info">
          <span class="spa1">{{newsDetail.authorName}}</span>
          <span class="spa2">{{newsDetail.publishTime | time_moment('YYYY-MM-DD HH:mm')}}</span>
        </div>
      </div>
    </div>
    <div class="news-content">
      <div class="custom-content" v-html="newsDetail.content"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import filter from 'js/filter'
import { getActAppMi } from '@/service/vbef'
export default {
  metaInfo() {
    return {
      title:
        this.newsDetail.title ||
        filter.dealLanguage(this.activityDetail.name, this.activityDetail.enName),
    }
  },
  data() {
    return {
      loading: false,
      newsDetail: {},
    }
  },
  components: {},
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user_key: (state) => state.user_key,
      activityDetail: (state) => state.activityDetail,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },
  created() {
    this.getActAppMi()
  },
  mounted() {},
  methods: {
    async getActAppMi() {
      this.loading = true
      let res = await getActAppMi({
        page: 1,
        size: 1,
        activityId: this.activityId,
        // isEnglish: this.language == 'en' ? 1 : 0,
        appMiId: this.$route.params.id,
      })
      this.loading = false
      if (res.code == 0 && res.data.length) {
        this.$set(this.$data, 'newsDetail', res.data[0])
      } else {
        this.$router.push('/404')
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
.main-container
  min-height calc(100vh - 64px)
.news-top
  padding 30px 0 20px
  border-bottom 1px solid #e5e5e5
  > div
    width 920px
    margin 0 auto
  .news-title
    font-size 20px
    color #333333
    line-height 28px
  .news-info
    margin-top 20px
    font-size 14px
    color #333333
    line-height 20px
    display flex
    align-items center
    span+span
      margin-left 10px
      padding-left 11px
      position relative
      &:before
        content ''
        position absolute
        left 0
        top 50%
        transform translateY(-50%)
        width 1px
        height 12px
        background #EEEEEE
.news-content
  width 920px
  margin 0 auto
  padding 40px 0
  >>>.custom-content
    overflow hidden
    width 100%
    font-size 16px
    color #1D2129
    line-height 1.8
    text-align justify
    img
      margin 0 auto
      display block
      max-width 100% !important
      height auto !important
    span
      max-width 100% !important
      padding 0
    p
      max-width 100% !important
      margin 0
      font-size 16px
      font-weight 500
      color #1D2129
      line-height 1.8
      text-align justify
    table
      width 100%
    table
      td
        border 1px solid #e5e5e5
    iframe
      width 100% !important
      height 200px !important
    section
      max-width 100% !important
      p
        margin inherit
        font-size inherit
        font-weight inherit
        color inherit
        line-height inherit
        text-align inherit
    video
      max-width 100% !important
      background #000
</style>